import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import "../../styles/Charts.css";

// Registrar os componentes necessários
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Charts = ({ data }) => {
  if (!data || !data.rondas || !data.ocorrencias || !data.inspecoes) {
    console.warn("⚠️ Dados do gráfico estão vazios ou inválidos:", data);
    return (
      <p style={{ textAlign: "center", fontSize: "14px", color: "#888" }}>
        Nenhum dado disponível para exibir os gráficos.
      </p>
    );
  }

  // **Dados do gráfico de Rondas**
  const rondasChartData = {
    labels: ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    datasets: [
      {
        label: "Rondas Realizadas",
        data: data.rondas.length ? data.rondas : [0, 0, 0, 0, 0, 0],
        borderColor: "blue",
        backgroundColor: "rgba(0, 123, 255, 0.5)",
      },
    ],
  };

  // **Dados do gráfico de Ocorrências**
  const ocorrenciasChartData = {
    labels: ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    datasets: [
      {
        label: "Ocorrências Registradas",
        data: data.ocorrencias.length ? data.ocorrencias : [0, 0, 0, 0, 0, 0],
        borderColor: "red",
        backgroundColor: "rgba(255, 0, 0, 0.5)",
      },
    ],
  };

  // **Dados do gráfico de Inspeções**
  const inspecoesChartData = {
    labels: ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    datasets: [
      {
        label: "Inspeções Concluídas",
        data: data.inspecoes.length ? data.inspecoes : [0, 0, 0, 0, 0, 0],
        borderColor: "green",
        backgroundColor: "rgba(40, 167, 69, 0.5)",
      },
    ],
  };

  // Opções de Configuração para Melhorar Visualização
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          font: {
            size: 14, // 🔥 Aumenta o tamanho da legenda
          },
        },
      },
      title: {
        display: true,
        font: {
          size: 20, // 🔥 Aumenta o tamanho do título dentro do gráfico
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Dias da Semana",
          font: {
            size: 16, // 🔥 Tamanho maior para o rótulo do eixo X
          },
        },
      },
      y: {
        title: {
          display: true,
          text: "Quantidade",
          font: {
            size: 16, // 🔥 Tamanho maior para o rótulo do eixo Y
          },
        },
      },
    },
  };

  return (
    <div className="charts">
      <h2 className="chart-title">Estatísticas Operacionais</h2> {/* 🔥 Título Principal */}
      
      <div className="chart">
        <h3 className="chart-subtitle">Rondas Realizadas</h3>
        <Line data={rondasChartData} options={{ ...options, plugins: { ...options.plugins, title: { text: "Rondas Realizadas" } } }} />
      </div>

      <div className="chart">
        <h3 className="chart-subtitle">Ocorrências Registradas</h3>
        <Bar data={ocorrenciasChartData} options={{ ...options, plugins: { ...options.plugins, title: { text: "Ocorrências Registradas" } } }} />
      </div>

      <div className="chart">
        <h3 className="chart-subtitle">Inspeções Concluídas</h3>
        <Bar data={inspecoesChartData} options={{ ...options, plugins: { ...options.plugins, title: { text: "Inspeções Concluídas" } } }} />
      </div>
    </div>
  );
};

export default Charts;
